import { Injectable } from '@angular/core';
import { Profile, UserInfo } from '@tekman/onmat/models';
import { UserService } from '@tekman/onmat/service/generic';
import { Observable, of } from 'rxjs';
import { StorageService } from '../../storage/storage.service';

declare global {
  interface Window {
    hj: {
      (...args: any[]): void;
      q?: any[];
    };
  }
}

@Injectable({
  providedIn: 'root',
})
export class HotjarService {
  constructor(private readonly userService: UserService, private localStorage: StorageService) {}

  setInfoHotjar(profile: Profile, userInfo: UserInfo, courseName: string): Observable<void> {
    window.hj =
      window.hj ||
      function (...args: any[]) {
        (window.hj.q = window.hj.q || []).push(args);
      };
    const currentTimeString = new Date();
    const userId = profile.myRoomId || null;
    window.hj('identify', userId, {
      isTry: userInfo.isDemo,
      isTeacher: this.userService.isTeacher() ? 'true' : 'false',
      schoolId: profile.schoolId,
      schoolName: profile.schoolName,
      activeAcademicYear: this.localStorage.selectedAcademicYear,
      currentAcademicYears: [this.localStorage.selectedAcademicYear],
      course: courseName,
      email: profile.username,
      name: profile.name,
      surname: profile.familyName,
      program: 'ONMAT_ZERO',
      language: profile.locale,
      region: profile.schoolRegion,
      roles: profile.roles.toString(),
      currentDayOfMonth: currentTimeString.getDate(),
      currentHour: currentTimeString.getHours(),
    });
    return of();
  }
}
